import React, { useEffect, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";

const PASARARegistration = () => {


  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  useEffect(() => {
    document.title = "PASARA Registration Service | State Compliance Registration in India";

    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content =
      "Apply for PASARA Registration online with expert assistance. Fast, hassle-free state compliance registration for businesses, firms, and professionals in India.";
    document.head.appendChild(meta);
  }, []);

  return (
    <div className="service-page">

      {/* HERO */}
      <section className="service-hero">
        <h1>PASARA Registration Service</h1>
        <p>State Compliance Registration for Businesses in India</p>
        <button className="hero-btn" onClick={scrollToContact} >
          Get Started Today
        </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          PASARA Registration is a mandatory state-level compliance requirement
          for businesses and professionals operating in certain states in India.
          It ensures compliance with professional tax and other local regulations.
        </p>
      </section>

      {/* WHO NEEDS */}
      <section className="service-section">
        <h2>Who Needs PASARA Registration?</h2>
        <div className="card">Private Limited Companies</div>
        <div className="card">LLPs & Partnership Firms</div>
        <div className="card">Proprietorship Businesses</div>
        <div className="card">Self-employed professionals</div>
        <div className="card">Employers with staff</div>
        <div className="card">Service providers & traders</div>
      </section>

      {/* PURPOSE */}
      <section className="service-section">
        <h2>Purpose of PASARA Registration</h2>
        <ul>
          <li>Ensures compliance with state tax laws</li>
          <li>Professional tax enrollment</li>
          <li>Legal recognition under state authorities</li>
          <li>Smooth business operations</li>
        </ul>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our PASARA Registration Services</h2>
        <ul>
          <li>Eligibility assessment</li>
          <li>Online application filing</li>
          <li>Documentation support</li>
          <li>Registration with authorities</li>
          <li>Certificate issuance assistance</li>
          <li>Post-registration guidance</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <div className="card">PAN Card</div>
        <div className="card">Aadhaar Card</div>
        <div className="card">Business Registration Proof</div>
        <div className="card">Address Proof</div>
        <div className="card">Bank Details</div>
        <div className="card">Partner/Director Details</div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>Registration Process</h2>
        <ul>
          <li>Eligibility check</li>
          <li>Document collection</li>
          <li>Online application filing</li>
          <li>Government verification</li>
          <li>Certificate issuance</li>
        </ul>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Registration</h2>
        <ul>
          <li>✔ Legal compliance</li>
          <li>✔ Avoid penalties</li>
          <li>✔ Smooth business operations</li>
          <li>✔ Required for local regulations</li>
          <li>✔ Improved credibility</li>
        </ul>
      </section>

      {/* WHY US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Expert compliance knowledge</li>
          <li>✔ Fast & error-free process</li>
          <li>✔ Complete documentation support</li>
          <li>✔ Affordable pricing</li>
          <li>✔ End-to-end assistance</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Get PASARA Registration Today</h2>
        <p>Stay compliant with state regulations easily.</p>
        <button>Apply Now</button>
      </section> */}

         <div className="cta" ref={contactRef}>
              <h2>Get PASARA Registration Today</h2>
              <p>Stay compliant with state regulations easily.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>

    </div>
  );
};

export default PASARARegistration;